import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import { AuthContext } from "../context/AuthContext";
import Web2LeadContainer from "../components/web2lead/index";
import "../assets/css/web-to-lead.css";

const Web2Lead = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isWebToLeadView } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
    if (!isWebToLeadView) {
      navigate("/dashboard-view");
    }
  }, [isWebToLeadView, navigate, isAuthenticated]);

  return <Web2LeadContainer />;
};

export default Web2Lead;
